export const userRoute = {
  path: '',
  loadChildren: () =>
    import('../../components/user-management/user-routing.module').then((m) => m.UserRoutingModule),
};

export const DataSpaceRoute = {
  path: '',
  loadChildren: () =>
    import('../../components/data-space/data-space-routing.module').then(
      (m) => m.DataSpaceRoutingModule
    ),
};
export const SystemConfigurationRoute = {
  path: '',
  loadChildren: () =>
    import('../../components/system-configuration/system-configuration-routing').then(
      (m) => m.SystemConfigurationRouting
    ),
};
export const ActivityRoute = {
  path: '',
  loadChildren: () =>
    import('../../components/activity-log/activity-routing.module').then(
      (m) => m.ActivityRoutingModule
    ),
};

export const IntegrationsRouting = {
  path: '',
  loadChildren: () =>
    import('../../components/integrations/integrations.routing').then((m) => m.IntegrationsRouting),
};
export const KPIRouting = {
  path: '',
  loadChildren: () =>
    import('../../components/kpi-dashboard/kpi-routing.module').then(
      (m) => m.KPIExplorerRoutingModule
    ),
};
